<!-- 促销方案 -->
<template>
    <div class="page_content">
        <!-- <subComponents ref="showSelectData"></subComponents> -->
        <el-dialog :visible.sync="showStatus" :title="actionData.cate === 0 ? '新增价格组' : '编辑价格组'" width="50%"
            :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false"
            :close-on-press-escape="true" center>
            <priceGroupModal v-if="showStatus" ref="priceGroupMastRef" @drawerCancel="drawerCancel" @toDetail="toDetail"
                :actionData="actionData"></priceGroupModal>
        </el-dialog>

        <div style="display: flex; justify-content: space-between">
            <div class="page_content_center" style="width: 30%">
                <div class="page_content_top">
                    <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"
                        @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData"
                            @openSearch="openSearch"></v-search>
                    </div>
                </div>
                <el-table ref="priceGroupTable" :key="tableFlag" stripe @selection-change="handleSelectionChange" @row-click="storePriceClick"
                    :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row
                    size="mini">
                    <!-- 主信息 -->
                    <el-table-column type="selection" header-align='center' width="80"></el-table-column>
                    <el-table-column v-for="(tableValye, tableKey) in pageShowData" :key="tableKey" align="center"
                        :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                        :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'startTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>


                            <span v-else-if="tableValye.entityField == 'startTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>

                            <span v-else-if="tableValye.entityField == 'endTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'conType'">
                                {{ Number(scope.row.conType) === 1 ? "按商品" : "按品系" }}
                            </span>
                            <span v-else-if="tableValye.entityField == 'resType'">
                                {{ Number(scope.row.resType) === 1 ? "赠送商品" : Number(scope.row.resType) === 2 ? "整单减金额"
                                    :
                                    "促销条件商品打折" }}
                            </span>
                            <span v-else-if="tableValye.entityField == 'roundType'">
                                {{ Number(scope.row.roundType) === 0 ? "全部" : Number(scope.row.roundType) === 1 ? "周" :
                                    "日" }}
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                    scope.row[tableValye.entityField]
                                    }}</a>
                            </span>


                            <el-input clearable style="width: 90px; margin: 0 1px"
                                @blur="blur(scope.$index, tableValye.entityField)"
                                v-else-if="tableValye.fieldType == 'input'" type="number"
                                v-model="scope.row[tableValye.entityField]"></el-input>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                        @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </div>
            <div style="width: 70%">
                <div class="page_content_top">
                    <v-button :buttonList="buttonList2" @actionSet="actionSet2" @getPageInfo="getPageInfo"
                        @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search :searchList="searchList2" :getRequestData="getRequestData2" @searchData="searchData2"
                            @openSearch="openSearch"></v-search>
                    </div>
                </div>

                <el-table class="mainTable xunjia" ref="mxTable" :data="BindList" :height="tableHeight"
                    @row-click="storePriceClick2" @selection-change="handleSelectionChange2" :key="$store.state.tableNum" border style="width: 100%"
                    highlight-current-row size="mini">
                    <el-table-column align="center" label="商品价格组信息">
                        <el-table-column type="selection" header-align='center' width="80"></el-table-column>
                        <el-table-column v-if="tableValye.isShow == 1"
                            v-for="(tableValye, tableKey) in pageShowPeopleData" :key="tableKey" align="center"
                            :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                            :min-width="tableValye.fieldWeight">
                            <template slot-scope="scope">
                                <span v-if="tableValye.entityField == 'goodType'">
                                    {{ Number(scope.row.goodType) === 0 ? "药品" : "器械" }}
                                </span>
                                <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                            </template>

                        </el-table-column>
                    </el-table-column>
                </el-table>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData2.page" :rows="getRequestData2.rows" :total="returnData2.total"
                        @setDataPageSize="setDataPageSize2" @setDataPageNumber="setDataPageNumber2"></v-pagination>
                </div>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
        </el-dialog>

        <!-- 商品价格组列表 -->
        <el-dialog :title="actionData.cate === 0 ? '新增商品价格' : '编辑商品价格'" v-if="storeVisible" :visible.sync="storeVisible"
            center>
            <div class="store-modal-content">
                <div class="data_action_form">
                    <el-card class="box-card" body-style="padding:10px;border:1px solid #E4E7ED">
                        <el-form :model="priceGroupForm" ref="priceGroupForm" label-width="100px" :show-message="false">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="零售价" prop="salesPrice">
                                        <el-input v-model="priceGroupForm.salesPrice" placeholder="请输入零售价" type="number"
                                            @input="calculateMemberPrice"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="折率" prop="discountRate">
                                        <el-input v-model="priceGroupForm.discountRate" placeholder="请输入折率(如0.9表示9折)"
                                            type="number" step="0.01" min="0" max="1"
                                            @input="calculateMemberPrice"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="会员价" prop="memberPrice">
                                        <el-input v-model="priceGroupForm.memberPrice" placeholder="请输入会员价"
                                            type="number"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="storeVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitPriceGroupForm">确 定</el-button>
            </div>
        </el-dialog>


        <customDesign ref="customDesign"></customDesign>

        <el-dialog title="请输入会员价折扣率" :visible.sync="showRateDialog" width="400px" @close="rate = ''">
            <el-form :model="rateForm" ref="rateForm" label-width="100px" :show-message="false">
                <el-form-item label="会员价折扣率" prop="rate">
                    <label slot="label" :style="$common.labelStyle('会员价折扣率')"
                        v-html="$common.htmlLabel('会员价折扣率')"></label>
                    <el-input v-model="rateForm.rate" placeholder="请输入折扣率" type="number" @input="validateRate"
                        autocomplete="off" @keyup.enter.native="submitRate"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showRateDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitRate">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="请输入统一会员价折扣率" :visible.sync="showRateDialog2" width="400px" @close="rate = ''">
            <el-form :model="rateForm2" ref="rateForm2" label-width="100px" :show-message="false">
                <el-form-item label="会员价折扣率" prop="rate">
                    <label slot="label" :style="$common.labelStyle('会员价折扣率')"
                        v-html="$common.htmlLabel('会员价折扣率')"></label>
                    <el-input v-model="rateForm2.rate" placeholder="请输入折扣率" type="number" @input="validateRate"
                        autocomplete="off" @keyup.enter.native="submitRate2"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showRateDialog2 = false">取 消</el-button>
                <el-button type="primary" @click="submitRate2">确 定</el-button>
            </div>
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../../byComponents/SearchScheme.vue"
import priceGroupModal from "./priceGroupModal.vue"
import { nameList, storeList, searchList, searchList2 } from "./priceGroupList.js"

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        priceGroupModal
    },
    data() {
        //这里存放数据
        return {
            sField: "",
            exTitle: "",
            exWidth: "",
            searchList: searchList,
            searchList2: searchList2,
            getRequestData: {
                businessId: "",
                creater: 0,
                ormId: 0,
                page: 1,
                rows: 30,
                start: "",
                end: "",
                groupName: "",
                groupCode: "",
            },
            getRequestData2: {
                businessId: "",
                bgmName: "",
                creater: 0,
                end: "",
                groupIdList: [],
                ormId: 0,
                page: 1,
                rows: 30,
                start: "",
            },
            //---------------
            seTitle: "",
            DialogVisible: false,
            seId: "",
            setField: "",
            setType: "",
            seWidth: "0",
            parentSearchData: {},
            //---------------
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            returnData2: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            buttonList2: [
                // { actionType: 0, jurName: '新增', icon: 'el-icon-plus' },
                { actionType: 1, jurName: '修改', icon: 'el-icon-edit' },
                { actionType: 2, jurName: '统一会员折扣率', icon: 'el-icon-delete' }
            ],
            multipleSelection: [],
            multipleSelection2: [],
            pageShowData: {},
            pageShowPeopleData: {},
            tableFlag: 0,
            selectedDataIndex: 0,
            groupIds: [],
            goodPriceIds: "",
            BindList: [],
            tableHeight: 0,
            showStatus: false,
            actionData: {},
            storeVisible: false,
            storeList: [],
            loading: false,
            searchPersonName: "",
            requesUrl: "",
            priceGroupForm: {
                // bgmName: '',
                // goodType: '', 
                // groupName: '',
                salesPrice: '',
                memberPrice: '',
                discountRate: '', // 折率
                // manufacturer: '',
                // spec: '',
                // placeorigin: '',
                bgmId: ''
            },
            showRateDialog: false, // 控制折扣率弹窗显示
            rate: '',              // 会员价折扣率
            rateForm: {
                rate: ''
            },
            showRateDialog2: false, // 控制折扣率弹窗显示
            rate2: '',              // 会员价折扣率
            rateForm2: {
                rate: ''
            }
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.pspmBuycus = ""
                }
            },
            deep: true,
        },


    },
    //方法集合
    methods: {
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            var formObj = {
                jurTableVo: {
                    jurconfigtable: this.pageShowPeopleData
                },
                jurFormVoList: [],
                jurHead: {
                    jurconfigform: []
                },
            }
            this.$refs['customDesign'].openBox(pathInfo.jurId, formObj, pathInfo.jurName)
        },
        // 子组件触发
        drawerCancel(e) {
            console.log(e, "+++++++++")
            this.showStatus = false
            // this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        storePriceClick(row) {
            // 检查当前行是否已被选中
            const isSelected = this.multipleSelection.some(item => item.id === row.id);
            
            // 如果当前只选中了一条数据且是当前行，则不允许取消选中
            if (isSelected && this.multipleSelection.length === 1) {
                return;
            }
            
            // 切换选中状态
            this.$refs.priceGroupTable && this.$refs.priceGroupTable.toggleRowSelection(row);
        },
        storePriceClick2(row) {
            // 检查当前行是否已被选中
            // const isSelected = this.multipleSelection2.some(item => item.bgmId === row.bgmId);
            
            // 切换选中状态
            this.$refs.mxTable && this.$refs.mxTable.toggleRowSelection(row);

        },
        // 计算会员价
        calculateMemberPrice() {
            // 只有当零售价和折率都有值时才计算会员价
            if (this.priceGroupForm.salesPrice && this.priceGroupForm.discountRate) {
                const salesPrice = parseFloat(this.priceGroupForm.salesPrice);
                const discountRate = parseFloat(this.priceGroupForm.discountRate);

                // 验证折率范围
                if (discountRate > 0 && discountRate <= 1) {
                    // 计算会员价 = 零售价 × 折率，保留2位小数
                    this.priceGroupForm.memberPrice = (salesPrice * discountRate).toFixed(2);
                }
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(val) {
            this.setType = val.type
            this.seId = val.sId
            this.setField = val.sField
            this.parentSearchData[this.setType] = this.getRequestData[this.setType]
            if (this.setType == 'bgmName') {
                this.parentSearchData.bgmId = this.getRequestData2.bgmId


            }
            this.DialogVisible = true

        },

        // 赋值字段
        paramValue(val) {
            let arr = this.setField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val) {
                if (this.setType == 'salesName') {
                    this.getRequestData.salesName = val.opmName
                    this.getRequestData.salesId = val.opmId
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false
        },
        //  新增门店绑定
        openStore() {
            this.storeVisible = true;
            this.searchPersonName = ""; // 重置搜索条件
            this.queryOperator();
        },
        //查询门店列表
        async queryOperator() {
            this.loading = true;
            let params = {
                businessId: "",
                creater: 0,
                end: 0,
                ormId: 0,
                page: 1,
                rows: 1000,
                start: 0,
                storeName: this.searchPersonName || "",
                storeType: ""
            };
            let responseData = await this.$http.storemastQueryAll(params);
            this.loading = false;
            if (responseData && responseData.status == 200) {
                // 直接显示所有门店，不进行过滤
                this.storeList = responseData.result || [];
                // 数据加载完成后自动勾选已绑定的门店
                this.$nextTick(() => {
                    this.autoSelectExistingStores();
                });
            } else {
                this.storeList = [];
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 自动勾选已绑定的门店 
        autoSelectExistingStores() {
            // 等待DOM更新完成
            this.$nextTick(() => {
                if (this.$refs.storeList && this.BindList.length > 0 && this.storeList.length > 0) {
                    const existIds = this.BindList.map(item => item.storeId);

                    // 先清空所有选择 
                    this.$refs.storeList.clearSelection();

                    // 勾选已绑定的门店
                    this.storeList.forEach(row => {
                        if (existIds.includes(row.storeId)) {
                            this.$refs.storeList.toggleRowSelection(row, true);
                        }
                    });

                    // 同步 multipleSelection
                    this.multipleSelection = this.storeList.filter(row => existIds.includes(row.storeId));
                }
            });
        },
        handleSelectionChange(val) {
            // console.log('选中的门店数据:', val);
            // 如果全反选（val为空数组）且表格有数据，则默认选中第一条
            if (val.length === 0 && this.returnData.list.length > 0) {
                this.$nextTick(() => {
                    this.$refs.priceGroupTable && this.$refs.priceGroupTable.toggleRowSelection(this.returnData.list[0], true);
                    this.multipleSelection = [this.returnData.list[0]];
                    this.groupIds = [this.returnData.list[0].id];
                    this.getDataStoreList();
                });
                return;
            }
            this.multipleSelection = val;
            this.groupIds = val.map(item => item.id);
            this.searchData2()
            // console.log('已绑定门店的id:', this.groupIds);
        },
        // 勾选商品价格明细
        handleSelectionChange2(val) {
            // console.log('选中的商品价格数据:', val);
            this.multipleSelection2 = val;
        },
        async seltore() {
            // 检查是否有选中的门店
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请先选择要绑定的门店",
                    type: "warning",
                });
                return;
            }

            // 准备保存的数据，直接使用勾选的门店数据
            let pushData = {
                storeIdList: this.multipleSelection.map(item => item.storeId),
                id: this.groupIds,
            };

            console.log('准备保存的门店数据:', pushData);

            // 直接调用保存接口
            let responseData = await this.$http.bindPlan(pushData);
            if (responseData.status == 200) {
                this.$message({
                    message: `成功绑定 ${this.multipleSelection.length} 个门店`,
                    type: "success",
                });
                // 重新获取门店列表
                this.getDataStoreList();
                // 关闭对话框
                this.storeVisible = false;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        async delDetail(index) {
            this.$confirm("确定删除该记录吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    try {
                        // 调用删除接口
                        let responseData = await this.$http.delstoreOper({
                            ids: [this.BindList[index].id],
                        });

                        if (responseData.status == 200) {
                            // 保存被删除的门店信息
                            const deletedStore = this.BindList[index];
                            // 从列表中删除
                            this.BindList.splice(index, 1);
                            // 如果当前正在显示门店选择对话框，则更新可选列表
                            if (this.storeVisible) {
                                this.storeList.push(deletedStore);
                            }
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.getDataStoreList()
                        } else {
                            this.$message({
                                message: responseData.message,
                                type: "error",
                            });
                        }
                    } catch (error) {
                        this.$message({
                            message: "删除失败，请重试",
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        getSeWidth(e) {
            console.log(e)
            this.seWidth = e + "%"
        },
        getWidth(e) {
            console.log(e)
            this.exWidth = e + "%"
        },
        getSearchName(e) {
            console.log(e)
            this.seTitle = e
        },



        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.pageShowData = JSON.parse(JSON.stringify(nameList))
                if (responseData.result.jurTableVo) {
                    this.pageShowPeopleData = responseData.result.jurTableVo.jurconfigtable
                }
                this.getDataList1()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }

        },
        async getDataList1() {
            let res = await this.$http.groupQuery(this.getRequestData)
            if (res.status == 200) {
                this.returnData.list = res.result.list
                this.returnData.total = res.result.total
                this.returnData.pageNum = res.result.pageNum
                this.returnData.pages = res.result.pages
                this.selectedDataIndex = 0
                this.multipleSelection = []
                if (this.returnData.list.length > 0) {
                    this.groupIds = [this.returnData.list[0].id]
                    this.getDataStoreList().then(() => {
                        if (this.returnData.list.length > 0) {
                            // 默认选中第一行
                            this.$refs.priceGroupTable && this.$refs.priceGroupTable.toggleRowSelection(this.returnData.list[0], true);
                            this.multipleSelection = [this.returnData.list[0]];
                        }
                    })
                } else {
                    this.BindList = []
                    this.groupIds = []
                }
                
                // 表格渲染完成后再执行选中操作
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }
        },
        // 获取表单配置
        async getFormData() {
            try {
                var pathId = parent.getMenuInfo(this.$route.path);
                let responseData = await this.$http.getJur({
                    ids: [pathId.jurId]
                });
                if (responseData.status == 200) {
                    this.formDataList = responseData.result.jurFormVoList || [];
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } catch (error) {
                console.error("获取表单配置失败:", error);
                this.$message({
                    message: "获取表单配置失败",
                    type: "error",
                });
            }
        },
        // 动作集合
        async actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: "",
                    }
                    break
                case 1:
                    if (this.multipleSelection.length === 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    if (this.multipleSelection.length > 1) {
                        this.$message({
                            message: "只能编辑一条数据",
                            type: "error",
                        })
                        return false
                    }
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: [],
                        oldData: this.multipleSelection[0],
                    }
                    break
                case 2:
                    this.delDataAction()
                    break

                case 4:
                    this.initDataAction()
                    break
                case 5:
                    this.exportData()
                    break
            }
        },
        actionSet2(actionData) {
            console.log(actionData.actionType, 'actionData.actionType')
            switch (actionData.actionType) {
                case 0:
                    this.storeVisible = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: "",
                    }
                    break
                case 1:
                    if (this.multipleSelection2.length === 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    this.storeVisible = true
                    this.priceGroupForm = this.multipleSelection2[0]
                    break
                case 2:
                    this.initDataAction2()
                    break
            }
        },


        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        searchData2() {
            this.getRequestData2.page = 1
            this.getDataList2()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },
        setDataPageNumber2(val) {
            this.getRequestData2.page = val
            this.getDataList2()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        setDataPageSize2(val) {
            this.getRequestData2.page = 1
            this.getRequestData2.rows = val
            this.getDataList2()
        },
        // 获取数据列表 方案
        async getDataList() {
            let responseData = await this.$http.groupQuery(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.returnData.pages = responseData.result.pages
                this.selectedDataIndex = 0
                this.multipleSelection = []
                if (this.returnData.list.length > 0) {
                    this.groupIds = [this.returnData.list[0].id]
                    this.getDataStoreList().then(() => {
                        if (this.returnData.list.length > 0) {
                            // 默认选中第一行
                            this.$refs.priceGroupTable && this.$refs.priceGroupTable.toggleRowSelection(this.returnData.list[0], true);
                            this.multipleSelection = [this.returnData.list[0]];
                        }
                    })
                } else {
                    this.BindList = []
                    this.groupIds = []
                }
                
                // 表格渲染完成后再执行选中操作
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        async getDataList2() {
            console.log(this.returnData, 'this.returnData.list[0]');

            this.getRequestData2.groupIdList = this.groupIds
            let responseData = await this.$http.bgmPriceGroupQuery(this.getRequestData2)
            if (responseData.status == 200) {
                this.returnData2.list = responseData.result.list.list
                this.returnData2.total = responseData.result.list.total
                this.returnData2.pageNum = responseData.result.list.pageNum
                this.returnData2.pages = responseData.result.list.pages
                // 修复：同时设置BindList数据
                this.BindList = responseData.result.list.list || []

                // 初始化第二个表格的选中状态
                if (this.BindList.length > 0) {
                    this.selectedRowIndex2 = 0
                    this.goodPriceIds = this.BindList[0].id
                } else {
                    this.selectedRowIndex2 = null
                    this.goodPriceIds = ""
                }
            }
        },
        // 查询当前门店绑定的人员
        async getDataStoreList() {
            this.BindList = []
            this.getRequestData2.groupIdList = this.groupIds
            let responseData = await this.$http.bgmPriceGroupQuery(this.getRequestData2)
            if (responseData.status == 200) {
                console.log(responseData.result, 'responseData.result');
                console.log(responseData.result.list.list, 'responseData.result.list');
                this.returnData2.list = responseData.result.list.list
                this.returnData2.total = responseData.result.list.total
                this.returnData2.pageNum = responseData.result.list.pageNum
                this.returnData2.pages = responseData.result.list.pages
                // 修复：直接使用responseData.result.list.list作为BindList的数据源
                this.BindList = responseData.result.list.list || []

                // 初始化第二个表格的选中状态
                if (this.BindList.length > 0) {
                    this.selectedRowIndex2 = 0
                    this.goodPriceIds = this.BindList[0].id
                } else {
                    this.selectedRowIndex2 = null
                    this.goodPriceIds = ""
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        // 删除数据
        delDataAction() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }

            this.$confirm(`此操作将永久删除选中的 ${this.multipleSelection.length} 条数据, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: this.multipleSelection.map(item => item.id),
                    }
                    let responseData = await this.$http.groupDel(delData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })

                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => { })
        },
        // 初始化数据
        initDataAction() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }
            if (this.multipleSelection.length > 1) {
                this.$message({
                    message: "只能初始化一条数据",
                    type: "error",
                })
                return false
            }
            const row = this.multipleSelection[0];

            this.rateForm.rate = '';
            this.showRateDialog = true; // 打开输入折扣率弹窗
        },
        //统一会员折扣率
        initDataAction2() {
            if (this.multipleSelection2.length === 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }
            if (this.multipleSelection2.length > 1) {
                this.$message({
                    message: "只能初始化一条数据",
                    type: "error",
                })
                return false
            }

            this.rateForm2.rate = '';
            this.showRateDialog2 = true; // 打开输入折扣率弹窗
        },
        delDataAction2() {
            if (this.multipleSelection2.length === 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }
            this.$confirm(`此操作将永久删除选中的 ${this.multipleSelection2.length} 条数据, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: this.multipleSelection2.map(item => item.bgmId),
                    }
                    let responseData = await this.$http.bgmPriceGroupDelete(delData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                        this.getDataList2()
                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => { })
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },

        // 门店搜索处理
        handlePersonSearch() {
            this.queryOperator();
        },

        handleRadioChange2(row, index) {
            this.selectedRowIndex2 = index;
            this.goodPriceIds = row.id;

        },
        submitPriceGroupForm() {
            // 这里可以做表单校验
            // this.$refs.priceGroupForm.validate((valid) => { ... })

            // 将修改后的价格字段赋值给 multipleSelection2 中的每一个商品
            const updatedItems = this.multipleSelection2.map(item => ({
                ...item,
                salesPrice: this.priceGroupForm.salesPrice,
                memberPrice: this.priceGroupForm.memberPrice,
                discountRate: this.priceGroupForm.discountRate
            }));

            // 提交批量修改请求
            this.$http.priceGroupBgmPriceGroupBatchUpdate({
               selectList:updatedItems
            }).then(response => {
                if (response.status == 200) {
                    this.$message.success('保存成功');
                    this.storeVisible = false;
                    this.getDataList2();
                } else {
                    this.$message.error(response.message);
                }
            });
        },
        validateRate(value) {
            // 移除非数字字符
            let numValue = value.replace(/[^\d.]/g, '');

            // 确保只有一个小数点
            const parts = numValue.split('.');
            if (parts.length > 2) {
                numValue = parts[0] + '.' + parts.slice(1).join('');
            }

            // 转换为数字
            const num = parseFloat(numValue);

            // 验证范围：0-1之间
            if (num < 0) {
                this.rateForm.rate = '0';
            } else if (num > 1) {
                this.rateForm.rate = '1';
            } else {
                this.rateForm.rate = numValue;
            }
        },
        async submitRate() {
            if (!this.rateForm.rate || isNaN(this.rateForm.rate)) {
                this.$message({
                    message: "请输入有效折扣率",
                    type: "warning",
                });
                return;
            }

            const rate = parseFloat(this.rateForm.rate);
            if (rate < 0 || rate > 1) {
                this.$message({
                    message: "折扣率必须在0-1之间",
                    type: "warning",
                });
                return;
            }

            this.showRateDialog = false;
            var Data = {
                id: this.multipleSelection[0].id,
                rate: this.rateForm.rate
            }
            let responseData = await this.$http.initPriceGroup(Data)
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "初始化成功!",
                })
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
        async submitRate2() {
            if (!this.rateForm2.rate || isNaN(this.rateForm2.rate)) {
                this.$message({
                    message: "请输入有效折扣率",
                    type: "warning",
                });
                return;
            }

            const rate = parseFloat(this.rateForm2.rate);
            if (rate < 0 || rate > 1) {
                this.$message({
                    message: "折扣率必须在0-1之间",
                    type: "warning",
                });
                return;
            }

            this.showRateDialog2 = false;
            var Data = {
                id: this.multipleSelection2[0].groupId,
                rate: this.rateForm2.rate
            }
            let responseData = await this.$http.initMemPriceGroup(Data)
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "初始化成功!",
                })
                this.getDataList2()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },
            //获取requesUrl的根路径
        getRequestUrl() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
        },

        //导出数据
        exportData() {
            // 检查是否选择了价格组
            if (!this.groupIds || this.groupIds.length === 0) {
                return this.$message.error('请先选择要导出的价格组');
            }
            
            // 构造导出URL
            const exportUrl = this.requesUrl + '/priceGroup/exportWebRetailOrderDetail';
            
            // 构造请求参数
            let params = '?';
            
            // 价格组ID（必填）
            params += `groupIdList=${this.getRequestData2.groupIdList}`;
            
            // 商品名称
            if (this.getRequestData2.bgmName) {
                params += `&bgmName=${this.getRequestData2.bgmName}`;
            }
            
            // 业务ID
            if (this.getRequestData2.businessId) {
                params += `&businessId=${this.getRequestData2.businessId}`;
            }
            
            // 创建人
            if (this.getRequestData2.creater) {
                params += `&creater=${this.getRequestData2.creater}`;
            }
            
            // 结束时间
            if (this.getRequestData2.end) {
                params += `&end=${this.getRequestData2.end}`;
            }
            
            // 开始时间
            if (this.getRequestData2.start) {
                params += `&start=${this.getRequestData2.start}`;
            }
            
            // 组织ID
            if (sessionStorage.getItem('ormId')) {
                params += `&ormId=${sessionStorage.getItem('ormId')}`;
            }
            console.log(exportUrl+params, 'params');
            // return 
            // 跳转到导出URL
            window.location.href = exportUrl + params;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.getButtonList()
        this.getRequestUrl()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
            this.tableFlag++
        })
    },
    updated() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
        })
    }, //生命周期 - 更新之后

}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.btns {
    display: flex;
    position: absolute;
    z-index: 999;
    padding-left: 10px;
    padding-top: 2px;
}

::v-deep.xunjia tr {
    height: 39px !important;
}

::v-deep.xunjia .el-button {
    font-size: 12px;
    padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
    color: #fff;
    background-color: #f56c6c;
    border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
    color: #fff;
    background-color: #f78989;
    border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
    height: 100% !important;
    position: absolute;
    top: 0;
    overflow: hidden;
    background-color: #fff;
    z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
    background-color: #fff;
}
</style>